import React from 'react';
import { motion } from 'framer-motion';
import { getAzureLoginUrl } from '../../utils/expenseApi';

export default function ExpenseLogin() {
  const handleMicrosoftLogin = () => {
    window.location.href = getAzureLoginUrl();
  };

  return (
    <div style={{
      minHeight: '100vh',
      background:
        'radial-gradient(70rem 30rem at 4% -6%, rgba(27,111,74,0.14), transparent 70%),' +
        'radial-gradient(46rem 28rem at 98% 12%, rgba(229,110,17,0.15), transparent 64%),' +
        'linear-gradient(160deg, #f0f9f4 0%, #f5f8f2 48%, #fff9ef 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Manrope','Segoe UI',system-ui,sans-serif",
    }}>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        style={{
          background: 'rgba(255,255,255,0.93)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(193,224,206,0.9)',
          borderRadius: 22,
          padding: '40px 36px',
          width: 390,
          boxShadow: '0 16px 48px rgba(13,74,38,0.14)',
        }}
      >
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 52, height: 52, borderRadius: 14,
            background: 'linear-gradient(130deg,#1b6f4a,#2d9a5f)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 14px',
            boxShadow: '0 8px 24px rgba(27,111,74,0.26)',
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="2"/>
              <line x1="2" y1="10" x2="22" y2="10"/>
            </svg>
          </div>
          <h1 style={{ margin: 0, fontSize: '1.4rem', fontFamily: "'Space Grotesk',sans-serif", color: '#0d2b1a', letterSpacing: '-0.02em' }}>
            Expense Management
          </h1>
          <p style={{ margin: '4px 0 0', fontSize: '0.87rem', color: '#4d7a5e' }}>
            Policy Enforcement · SAP Posting
          </p>
        </div>

        {/* Microsoft / Azure AD button */}
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.97 }}
          onClick={handleMicrosoftLogin}
          style={{
            width: '100%', padding: '11px 0',
            background: '#fff', color: '#0f2118',
            border: '1.5px solid #c1e0ce', borderRadius: 10,
            fontSize: '0.9rem', fontWeight: 700, fontFamily: 'inherit',
            cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            boxShadow: '0 2px 8px rgba(13,74,38,0.07)',
          }}
        >
          <svg width="18" height="18" viewBox="0 0 21 21" fill="none">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
            <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
          </svg>
          Sign in with SAVIC Account
        </motion.button>


      </motion.div>
    </div>
  );
}
